export const newFields = [
    'invite_to_creator_accept_new',
    'accept_to_ops_approved_new',
    'ops_approved_to_post_new',
    'post_accepted_rate_new'
];

export const reactivatedFields = [
    'invite_to_creator_accept_reactivated',
    'accept_to_ops_approved_reactivated',
    'ops_approved_to_post_reactivated',
    'post_accepted_rate_reactivated'
];

export const calculatedFields = [
    'invite_to_approved_post_new',
    'invite_to_approved_post_reactivated'
];

export const campaignFields = ['skew_new', 'overdelivery_goal', 'skew_to_end_early'];

export const allFlightPlanFields = calculatedFields.concat(
    newFields,
    reactivatedFields,
    campaignFields
);



// WEBPACK FOOTER //
// ./invite_flights/constants/invite_flight_percentages.js